import React from 'react';
import './Badge.css';

/**
 * Badge
 * @param {string} color - 'green' | 'gold' | 'sky' | 'red' | 'gray'
 */
export default function Badge({ children, color = 'green' }) {
  return <span className={`badge badge--${color}`}>{children}</span>;
}
